export const LogoShortSvg: React.FC<{ width?: string; height?: string }> = ({
  width = 16,
  height = 16,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_22_2003)">
        <path
          d="M8.12187 15.8054L4.87455 11.4931L7.25821 8.32542L12.8964 15.8054H8.12187Z"
          fill="#FFA500"
          stroke="white"
          stroke-width="0.389201"
        />
        <path
          d="M13.2868 0H8.02481L2 8.00198L4.63099 11.4931L7.25809 8.00198L13.2868 0Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_22_2003">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LogoSvg: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="16"
      viewBox="0 0 41 16"
      fill="none"
    >
      <g clip-path="url(#clip0_203_4331)">
        <path
          d="M16.0727 7.57329V15.7307H14.9491L14.839 14.6293C14.31 15.4159 13.4286 16 12.173 16C10.0579 16 8.5155 14.6739 8.5155 12.3819C8.5155 10.09 9.94773 8.85391 12.4817 8.85391H14.7734V7.59557C14.7734 5.86547 13.9804 4.94327 12.4817 4.94327C11.1596 4.94327 10.2564 5.70757 10.1681 7.01047H8.86786C8.95619 4.98783 10.3884 3.66168 12.5254 3.66168C14.6623 3.66168 16.0727 5.16704 16.0727 7.57232V7.57329ZM14.7725 12.4052V10.09H12.437C10.7408 10.09 9.83756 10.8988 9.83756 12.4052C9.83756 13.9115 10.8728 14.6971 12.3715 14.6971C13.8702 14.6971 14.7734 13.7536 14.7734 12.4052H14.7725Z"
          fill="black"
        />
        <path
          d="M25.7868 8.17968V15.7307H24.4866V8.38214C24.4866 6.00011 23.8702 4.92098 22.3497 4.92098C20.7417 4.92098 19.6837 6.29169 19.6837 8.58363V15.7297H18.3835V3.9329H19.4634L19.6837 5.3937C20.2782 4.33782 21.2698 3.6636 22.6802 3.6636C24.5531 3.6636 25.7868 4.94422 25.7868 8.18065V8.17968Z"
          fill="black"
        />
        <path
          d="M32.8768 14.5838V15.8421H32.2157C30.1006 15.8421 28.9324 14.4937 28.9324 12.224V5.16897H27.1697V3.93291H28.9324V1.21378H30.2326V3.93291H32.6118V5.16897H30.2326V12.225C30.2326 13.7759 30.849 14.5847 32.2157 14.5847H32.8768V14.5838Z"
          fill="black"
        />
        <path
          d="M41 14.4946V15.7307H34.0601V14.6516L39.26 5.16801H34.3023V3.93195H40.8243V4.98783L35.6244 14.4937H41V14.4946Z"
          fill="black"
        />
        <path d="M1.50346 0H0V15.7307H1.50346V0Z" fill="#FFA500" />
        <path
          d="M6.43933 0H8.13559L2.47125 7.86487L8.38633 15.7307H6.68911L0.894653 7.96174L6.43933 0Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_203_4331">
          <rect width="41" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LogoHeaderSvg: React.FC = () => {
  return (
    <svg
      width="27"
      height="36"
      viewBox="0 0 27 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_19_1869)">
        <path
          d="M6.26653 35.5L0 33.8594V2.05944L6.26653 0.5V35.5Z"
          fill="white"
        />
        <path
          d="M9.67113 2.14056H6.89062V33.8594H9.67113V2.14056Z"
          fill="#F04FB6"
        />
        <path
          d="M27 2.14056H19.2953L8.10815 18L19.2953 33.8594H27L16.5094 18.9861L11.9614 23.4625L27 2.14056Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_19_1869">
          <rect
            width="27"
            height="35"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
